module.exports = __webpack_public_path__ + "assets/images/invisible-asia/2-china.jpg?v=4bcdca21";